/**
 * Generic CRUD operations for Supabase.
 *
 * Every entity service delegates here so the raw Supabase calls
 * live in one place (Dependency Inversion).  If the backend ever
 * changes, only this file needs updating.
 */
import { supabase } from '../supabaseClient';
import { getOrgId } from './orgStore';

/* ---------- READ ---------- */

export const fetchRecords = async (
  table,
  { select = '*', searchField, searchTerm, orderBy } = {}
) => {
  let query = supabase.from(table).select(select);

  if (searchField && searchTerm) {
    query = query.ilike(searchField, `%${searchTerm}%`);
  }

  if (orderBy) {
    query = query.order(orderBy.field, {
      ascending: orderBy.ascending ?? true,
    });
  }

  const { data, error } = await query;
  if (error) throw error;
  return data || [];
};

/* ---------- CREATE ---------- */

export const createRecord = async (table, payload) => {
  const { data, error } = await supabase
    .from(table)
    .insert([{ ...payload, org_id: getOrgId() }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

/* ---------- UPDATE ---------- */

export const updateRecord = async (table, primaryKey, id, payload) => {
  const { error } = await supabase
    .from(table)
    .update(payload)
    .eq(primaryKey, id);
  if (error) throw error;
};

/* ---------- DELETE ---------- */

export const deleteRecord = async (table, primaryKey, id) => {
  const { error } = await supabase
    .from(table)
    .delete()
    .eq(primaryKey, id);
  if (error) throw error;
};
